// FormPreview.tsx
import React, { useState } from 'react';
import { BuilderField } from './types/BuilderField';
import { DynamicForm } from './renderer/DynamicForm';

export interface FormPreviewProps {
  fields: BuilderField[];
}

/**
 * Public component. Internally just DynamicForm with local, throwaway state —
 * so the builder's "Preview" and the real runtime form are guaranteed to
 * render identically, with zero duplicated layout/rendering logic.
 *
 *   <FormPreview fields={builderFields} />
 */
export function FormPreview({ fields }: FormPreviewProps) {
  const [values, setValues] = useState<Record<string, any>>({});
  return (
    <DynamicForm
      fields={fields}
      values={values}
      onChange={(key, value) => setValues((prev) => ({ ...prev, [key]: value }))}
      hideSubmit
    />
  );
}

export default FormPreview;